import React, { forwardRef } from 'react'
import cx from 'classnames'

import s from './Row.scss'


const Row = forwardRef(({ children, className, id, align = 'center', justify, column, onClick }, ref) => (
  <div
    ref={ref}
    className={cx(s.row, className, {
      [s[`align-${align}`]]: Boolean(align),
      [s[`justify-${justify}`]]: Boolean(justify),
      [s.column]: column,
      [s.pointer]: !!onClick,
    })}
    id={id}
    onClick={onClick}
  >
    {children}
  </div>
))


export default React.memo(Row)
